import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements OnInit, OnChanges {
  @Input()
  checklistId: number;
  @Input()
  items = [];
  selectedItems = [];
  selectedItemsCount = 0;
  score = 0;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.checklistId.currentValue !== changes.checklistId.previousValue) {
      this.selectedItems = [];
      this.score = 0;
      this.recalculateScore();
    }
  }

  toggleItem(item) {
    this.checkSelected(item);

    this.recalculateScore();
  }

  recalculateScore() {
    this.score = Math.round((this.selectedItems.length / this.items.length) * 100);
  }

  private checkSelected(item) {
    if (this.selectedItems.includes(item.id)) {
      this.selectedItems.splice(this.selectedItems.indexOf(item.id), 1);
      return;
    }

    this.selectedItems.push(item.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/checklist/checklist.component.ts